import React from 'react'

export default function NullComp (props) {
  return null
}


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/NullComp.js